import React, { useEffect } from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/survey/action-in-calculator-list/image001.png';
import image002 from '../assetes/images/survey/action-in-calculator-list/image002.png';
import image003 from '../assetes/images/survey/action-in-calculator-list/image003.png';
import image004 from '../assetes/images/survey/action-in-calculator-list/image004.png';
import image005 from '../assetes/images/survey/action-in-calculator-list/image005.png';
import image006 from '../assetes/images/survey/action-in-calculator-list/image006.png';
import image007 from '../assetes/images/survey/action-in-calculator-list/image007.png';
import image008 from '../assetes/images/survey/action-in-calculator-list/image008.png';
import image009 from '../assetes/images/survey/action-in-calculator-list/image009.png';
import image010 from '../assetes/images/survey/action-in-calculator-list/image010.png';
import image011 from '../assetes/images/survey/action-in-calculator-list/image011.png';
import image012 from '../assetes/images/survey/action-in-calculator-list/image012.png';
import image013 from '../assetes/images/survey/action-in-calculator-list/image013.png';
import image014 from '../assetes/images/survey/action-in-calculator-list/image014.png';
import image015 from '../assetes/images/survey/action-in-calculator-list/image015.png';
import image016 from '../assetes/images/survey/action-in-calculator-list/image016.png';
import image017 from '../assetes/images/survey/action-in-calculator-list/image017.png';
import image018 from '../assetes/images/survey/action-in-calculator-list/image018.png';
import image019 from '../assetes/images/survey/action-in-calculator-list/image019.png';
import image020 from '../assetes/images/survey/action-in-calculator-list/image020.png';
import image021 from '../assetes/images/survey/action-in-calculator-list/image021.png';
import image022 from '../assetes/images/survey/action-in-calculator-list/image022.png';
import image023 from '../assetes/images/survey/action-in-calculator-list/image023.png';
import image024 from '../assetes/images/survey/action-in-calculator-list/image024.png';
import image025 from '../assetes/images/survey/action-in-calculator-list/image025.png';

export default function CustomVariable() {

useEffect(() => {
window.scrollTo(0, 0);
}, []);

return (
<>
    <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
            <DocumentationSidebar />


            <div className="flex-grow-1 dashboard-page-outer">
                <div className='dashboard-page-wrap document-page-wrap'>
                    <Searchbar containerSelector=".search-scope" />
                    <div className='search-scope mt-4'>
                        <h1 className='mt-0 text-primary'>Custom Variable</h1>
                        <p className='header-para'>
                            The Calculator module is designed to enable users to build and manage ROI (Return on
                            Investment) calculators that demonstrate the business value or potential savings a customer
                            can expect from using a specific product or solution.
                        </p>

                        <div className="card dashboard-card mb-4">
                            <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                Custom Variable
                            </div>
                            <div className="card-body">
                                <img src={image017} alt="Calculations & Logics" className='img-fluid pt-10 pb-10' />

                                <p> This section allows you to manage custom variables used within logic calculations,
                                    form conditions, or dynamic rules.</p>
                                <p>Custom Variables provide a way to assign dynamic values based on conditions defined
                                    in the Stage module. These variables are standalone and have unique names that can
                                    be used to reference and utilize their values throughout the system. The syntax to
                                    access the value of a custom variable is #[fieldName]#. </p>

                                <p>
                                    Example: Suppose you have a roi calculator form where participants provide feedback
                                    and rate their overall experience on a scale of 1 to 10. Based on their response,
                                    you want to assign a recommendation to a custom variable named "recommendation". The
                                    recommendation will indicate whether the participant would take your service, with
                                    values such as "Yes", "No", or "Maybe". The recommendation can be given for every
                                    question as per the selected answer using custom variables.
                                </p>


                                <p><b>Custome Variable List Table</b></p>
                                <ul>
                                    <li><b>Variable Name - </b> The name of the custom variable (e.g., test variable).
                                    </li>
                                    <li><b>Value - </b>The assigned value to that variable (e.g., 100). </li>
                                    <li><b>Created By - </b>The user who created the variable.</li>
                                    <li><b>Status - </b>Indicates if the variable is currently Active or not.

                                    </li>
                                    <li><b>Actions - </b>
                                        <ul>
                                            <li className='pt-10'><b>Edit -</b> On click, a pre-defined form will open
                                                for editing the selected logic.
                                                <img src={image018} alt="edit" className='pt-10 pb-10 img-fluid' />
                                            </li>
                                            <li><b>Delete -</b> On click, a confirmation popup will appear to delete the
                                                selected variable.
                                                <img src={image019} alt="delete" className='pt-10 pb-10' />
                                            </li>

                                        </ul>
                                    </li>
                                </ul>

                                <p><b>Form Fields </b> - When the Create button is clicked, the custome variable form
                                    will open as below
                                    <img src={image023} alt="Form Fields" className='img-fluid pt-10 pb-10' />
                                </p>
                                <ul>
                                    <li><b>Variable Name - </b>A descriptive label for the variable. It helps you
                                        understand what this value is for <br />
                                        <img src={image020} alt="Variable Name" className='pt-10 pb-10' /> <br />
                                        Example use: If you’re configuring pricing, this name could refer to a specific
                                        tier of users for a service.
                                    </li>
                                    <li><b>Variable Value - </b>This is the actual value the variable holds. In this
                                        case, it could be the cost or rate per user or group.<br />
                                        <img src={image021} alt="Variable Value" className='pt-10 pb-10' /><br />
                                        Example: $4.50 could mean 4.50 units of currency per user/month.
                                    </li>
                                    <li><b>Variable Type - </b> Select the data type of the variable — for example:
                                        Text, Number, or Currency.
                                        Determines how the variable is interpreted and used in formulas or
                                        display.<br />
                                        <img src={image022} alt="Variable Type" className='pt-10 pb-10' />
                                        <ul>
                                            <li>Number: Pure numerical value with no formatting.</li>
                                            <li>Currency: Interprets the number as a monetary amount (likely formats it
                                                as $4.50, ₹4.50, etc.).</li>
                                            <li>Text: Use this if the value is not numerical, e.g., "Standard Tier" or
                                                "Enabled".</li>
                                        </ul>
                                    </li>

                                </ul>

                            </div>
                        </div>

                        <div className="card dashboard-card mb-4">
                            <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                Example Use Cases
                            </div>
                            <div className="card-body">
                                <img src={image018} alt="Calculations & Logics" className='img-fluid pt-10 pb-10' />
                                <ul>
                                    <li><b>Variable Name:</b>  Operator Connect - 5 to 15 users

                                        <ul>
                                            <li>This is a unique, human-readable identifier for the data. It clearly
                                                describes what the value represents: the price for the "Operator
                                                Connect" service when the number of users is between 5 and 15.</li>
                                        </ul>
                                    </li>
                                    <li><b>Variable Value:</b>  4.50
                                        <ul>
                                            <li>This is the actual data being stored. In this instance, it's the price
                                                for the service tier.</li>
                                        </ul>
                                    </li>
                                    <li><b>Variable Type:</b>  Currency
                                        <ul>
                                            <li>This defines the data's format and tells the system how to interpret the
                                                value. By setting the type to "Currency," the system knows to treat
                                                "4.50" as a monetary amount, which is essential for correct financial
                                                calculations and display formatting (e.g., ensuring two decimal places).
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        When a user selects a value between 5 and 15, the system may assign a Variable Value of 4.50, depending on how the logic is configured. This value can potentially be used in several areas, such as displaying it on the thank you page, including it in the final report, or applying it in subsequent calculations. It may also be reflected in graphical representations within the report, depending on the specific setup. However, it's important to note that the use of this value is not guaranteed in all scenarios—its application depends on how the calculation logic and variable mappings are defined for the particular use case.
                                    </li>
                                </ul>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</>
)
}